import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { forkJoin, Observable } from 'rxjs';
import { catchError, map, pluck, switchMap } from 'rxjs/operators';
import * as UserActions from './actions';
import * as ErrorActions from '../error-store/actions';
import { UserHttpService } from 'src/app/common/services/http-services/user/user-http.service';
import { AppConfigService } from 'app-config';

@Injectable()
export class UserEffects {
    constructor(
        private actions$: Actions,
        private userHttpService: UserHttpService
    ) {}

    @Effect()
    getUserPermissions$: Observable<Action> = this.actions$.pipe(
        ofType(UserActions.ActionTypes.GET_USER_PERMISSIONS),
        pluck('payload'),
        switchMap(() => {
            return forkJoin([
                this.userHttpService.getCombinedPermission()
            ]).pipe(
                map(([isCombinedPermissionResponse]) => {

                    const api = AppConfigService.settings.apiServer.ptUserReportsService;

                    const isTeamLeadPermission = isCombinedPermissionResponse.filter((permissionObj) => {
                        return (permissionObj.resource === api.endpoints.isTeamLead)
                    });
                    const isTeamLead = (isTeamLeadPermission[0].access_allowed === 'true'? true :false);

                    const isCAPStaffPermission = isCombinedPermissionResponse.filter((permissionObj) => {
                        return (permissionObj.resource === api.endpoints.isCAPStaff)
                    });
                    const isCAPStaff = (isCAPStaffPermission[0].access_allowed === 'true'? true :false);

                    const isCommitteeMemberPermission = isCombinedPermissionResponse.filter((permissionObj) => {
                        return (permissionObj.resource === api.endpoints.isCommitteeMembers)
                    });
                    const isCommitteeMember = (isCommitteeMemberPermission[0].access_allowed === 'true'? true :false);

                    return new UserActions.GetUserPermissionsSuccess({
                        isTeamLead,
                        isCAPStaff,
                        isCommitteeMember
                    });
                }),
                catchError((err) => [
                    new UserActions.GetUserPermissionsFailure(err),
                    new ErrorActions.ShowUnexpectedError(err),
                ])
            );
        })
    );
}
